import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate } from "@/lib/utils";
import { MapPin, Package, Calendar, Truck, ArrowRight, Filter } from "lucide-react";

export default function Beiladungen() {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ von: "", nach: "", fahrzeug: "", min_volumen: "" });
  const [params] = useSearchParams();
  const highlight = params.get("trip");

  const load = async () => {
    setLoading(true);
    const p = {};
    Object.entries(f).forEach(([k, v]) => { if (v) p[k] = v; });
    const { data } = await api.get("/public/beiladungen", { params: p });
    const sorted = highlight ? [...data].sort((a, b) => (a.id === highlight ? -1 : b.id === highlight ? 1 : 0)) : data;
    setTrips(sorted); setLoading(false);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div className="eb-container py-12">
      <span className="eb-label text-[#FF5A1F]">Live-Verfügbarkeit</span>
      <h1 className="font-head text-3xl lg:text-4xl font-bold mt-2 mb-2">Aktuelle Beiladungen</h1>
      <p className="text-slate-400 mb-8 max-w-2xl">Nur reale, aktive Routen mit freiem Laderaum. Finde deine passende Fahrt.</p>

      <div className="eb-card p-5 mb-8">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 items-end">
          <div><label className="eb-label">Von</label><input className="eb-input mt-1.5" value={f.von} onChange={set("von")} placeholder="Ort/PLZ" data-testid="filter-von" /></div>
          <div><label className="eb-label">Nach</label><input className="eb-input mt-1.5" value={f.nach} onChange={set("nach")} placeholder="Ort/PLZ" data-testid="filter-nach" /></div>
          <div><label className="eb-label">Fahrzeug</label>
            <select className="eb-input mt-1.5" value={f.fahrzeug} onChange={set("fahrzeug")} data-testid="filter-fahrzeug">
              <option value="">Alle</option>{["Transporter","3,5 t","7,5 t","LKW","Sattelzug"].map(v=><option key={v}>{v}</option>)}
            </select></div>
          <div><label className="eb-label">Min. m³</label><input type="number" className="eb-input mt-1.5" value={f.min_volumen} onChange={set("min_volumen")} data-testid="filter-volumen" /></div>
          <button onClick={load} className="eb-btn-primary" data-testid="filter-apply-btn"><Filter className="w-4 h-4" /> Filtern</button>
        </div>
      </div>

      {loading ? <div className="text-slate-400">Lädt…</div> : trips.length === 0 ? (
        <div className="eb-card p-10 text-center">
          <p className="text-slate-300 mb-4">Aktuell ist keine passende Beiladung verfügbar.</p>
          <Link to="/anfrage" className="eb-btn-primary">Anfrage stellen</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {trips.map((t) => (
            <div key={t.id} className={`eb-card eb-card-hover p-6 ${t.id === highlight ? "ring-2 ring-[#FF5A1F]" : ""}`} data-testid={`beiladung-card-${t.id}`}>
              <div className="flex items-center justify-between mb-4">
                <span className="eb-badge bg-emerald-500/15 text-emerald-400 mono">{t.freie_m3} m³ frei</span>
                <span className="text-xs text-slate-500 flex items-center gap-1"><Truck className="w-3.5 h-3.5" /> {t.vehicle_type}</span>
              </div>
              <div className="flex items-center gap-2 font-head text-lg font-semibold">
                <MapPin className="w-4 h-4 text-[#FF5A1F]" /> {t.start_ort}
                <ArrowRight className="w-4 h-4 text-slate-600" /> {t.ziel_ort}
              </div>
              <div className="flex items-center gap-2 text-sm text-slate-400 mt-2">
                <Calendar className="w-4 h-4" /> Abfahrt {fmtDate(t.abfahrt)}
              </div>
              <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-800">
                <div><div className="text-xs text-slate-500">ab</div><div className="font-head text-xl font-bold text-[#FF5A1F]">{t.ab_preis} €<span className="text-xs text-slate-500 font-normal"> / m³ Richtwert</span></div></div>
                <Link to="/anfrage" className="eb-btn-outline !py-2 !px-3 text-xs" data-testid={`beiladung-book-${t.id}`}>Anfragen</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
